import React from 'react';
import DateTimeInput from '../DateTimeInput';
import moment from 'moment/moment';
import { create } from 'react-test-renderer'
import { fireEvent, render, screen } from '@testing-library/react';

describe('DateTimeInput Component', () => {
  const onChange = jest.fn();

  it('renders DateInput and TimeInput', () => {
    const selectedDate = moment.utc(new Date());
    render(<DateTimeInput onChange={onChange} selected={selectedDate} />);
    expect(screen.getByRole('textbox', { name: selectedDate.format('MM/DD/YYYY') })).toBeInTheDocument();
    expect(screen.getByRole('textbox', { name: selectedDate.format('hh:mm A')})).toBeInTheDocument();
  });

  it('renders clear', () => {
    render(<DateTimeInput onChange={onChange} isClearable />);
    expect(screen.getByRole('img', { name: new RegExp('close', 'i') })).toBeInTheDocument();
  });
  
  it('should call onChange when clear button is pressed and is clearable', ()=>{
    const onChange = jest.fn();
    render(<DateTimeInput onChange={onChange} isClearable={true} />);
    fireEvent.click(screen.queryByRole('img', { name: new RegExp('close', 'i') }));
    expect(onChange).toHaveBeenCalledTimes(1);
  });

  it('does not render icons when hideIcons is true', () => {
    const { rerender } = render(<DateTimeInput hideIcons onChange={onChange} />);
    expect(screen.queryByRole('img', { name: new RegExp('calendar', 'i') })).not.toBeInTheDocument();
    expect(screen.queryByRole('img', { name: new RegExp('time', 'i') })).not.toBeInTheDocument();
    rerender(<DateTimeInput onChange={onChange} hideIcons={false} />);
    expect(screen.queryByRole('img', { name: new RegExp('calendar', 'i') })).toBeInTheDocument();
    expect(screen.queryByRole('img', { name: new RegExp('time', 'i') })).toBeInTheDocument();
  });
  
  it('renders info message', () => {
    const infoMessage = 'info';
    render(<DateTimeInput infoMessage={infoMessage} onChange={onChange}/>);
    expect(screen.getAllByRole('img', { name: new RegExp('info', 'i') }).length).toBe(2);
    expect(screen.getAllByText(
      (content, element) => content === infoMessage && element.tagName.toLowerCase() === 'span')
    .length).toBe(2);
  });

  it('renders success message', () => {
    const successMessage = 'success';
    render(<DateTimeInput successMessage={successMessage} onChange={onChange}/>);
    expect(screen.getAllByRole('img', { name: new RegExp('success', 'i') }).length).toBe(2);
    expect(screen.getAllByText(
      (content, element) => content === successMessage && element.tagName.toLowerCase() === 'span')
    .length).toBe(2);
  });

  it('renders error message', () => {
    const errorMessage = 'error';
    render(<DateTimeInput errorMessage={errorMessage} onChange={onChange} />);
    expect(screen.getAllByRole('img', { name: new RegExp('error', 'i') }).length).toBe(2);
    expect(screen.getAllByText(
      (content, element) => content === errorMessage && element.tagName.toLowerCase() === 'span')
    .length).toBe(2);
  });

  describe('snapshots', () => {
    it('should match snapshot', () => {
      const component = create(<DateTimeInput selected={moment.utc('00:00', true)} onChange={onChange}/>).toJSON();
      expect(component).toMatchSnapshot();
    });
    
    it('should match different locale snapshot', () => {
      const component = create(<DateTimeInput locale={"bn"} selected={moment.utc('00:00', true)} onChange={onChange} />).toJSON();
      expect(component).toMatchSnapshot();
    });
  });
});
